import { columnsOrderedTable } from "@thelpers/columnsTableHelper"

export const columnsLogsTableHelper = ({ columns }) => {

    const defaultColumns = [
        {
            title: 'Fecha',
            dataIndex: 'created_at',
            key: 'created_at',
        },
        {
            title: 'Realizado por',
            dataIndex: 'updated_by',
            key: 'updated_by',
        },
        {
            title: 'Notas',
            dataIndex: 'changes',
            key: 'changes',
            render: (_, record) => {
                return (
                    <div className="collection-administration-table-action">
                        <ul>
                            {
                                record?.changes?.map((item, index) => ({ change: item, key: index })).map((item) => {
                                    return (
                                        <li key={item.key} style={{ textAlign:'left' }}>
                                            {item.change}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                )
            }
        },
    ]
    return columns?.length ? columnsOrderedTable({
        defaultColumns,
        backendColumns: columns,
        titleUpperCase: true,
        ignoreColumns: ['charge_status_code']
    }) : defaultColumns
}

export const columnsLogsTableFilters = ({ currentParams }) => {
    const sort_order = currentParams?.sort_order === 'desc' ? 'descend' : 'ascend'

    return {
        created_at: () => ({
            sorter: (a, b) => {
            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'created_at' ? sort_order : null,
        }),
        updated_by: () => ({
            sorter: (a, b) => {
            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'updated_by' ? sort_order : null,
        }),
        changes: () => ({
            sorter: (a, b) => {
            },
            sortDirections: ["descend", "ascend"],
            sortOrder: currentParams?.sort_by === 'changes' ? sort_order : null,
        }),
        default: () => ({}),
    }
}